import { useState } from "react";
import FormItem from "../components/formItem";
import Button from "../components/button";
import PasswordForm from "../components/passwordForm";
import useAuth from "../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import Mockup from "../assets/mockup.png";

export default function Register() {
  const [formValues, setFormValues] = useState({
    "name": "",
    "email": "",
   "password": "",
  });

  const [error, setError] = useState(null);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleUsernameChange = (value) => {
    setFormValues((prev) => ({
      ...prev,
      "name": value,
    }));
  };
  const handleEmailChange = (value) => {
    setFormValues((prev) => ({
      ...prev,
      "email": value,
    }));
  };

  const handlePasswordChange = (value) => {
    setFormValues((prev) => ({
      ...prev,
      "password": value,
    }));
  };


  const handleSubmit = async () => {
    try {
      setError(null);
      await register(formValues); 
    } catch (err) {
      setError(err.message); 
    }
  };

  const handleLoginNavigation = () => {
    navigate("/login");
  };

  const isButtonDisabled = !formValues.email.trim() || !formValues.password.trim || !formValues.name.trim();


  return (
    <section className="w-full h-screen overflow-hidden bg-base flex flex-row justify-center items-center px-[20px] py-[24px]">
      <div className="hidden h-full md:flex w-1/2 p-[12px] rounded-[12px] bg-secondary">
        <img src={Mockup} style={{ objectPosition: "50% 70%" }} className="w-full  object-cover rounded-[12px]" alt="" />
      </div>
      <div className="w-full md:w-1/2 flex items-center justify-center">
        <div className="content flex w-full md:w-[50%]  h-auto flex-col items-center gap-[37px]">
          <p className="flex flex-col items-center text-center text-text text-26-700">
            Sign Up
            <button className="text-14-500" onClick={handleLoginNavigation}>
              you have an account?
              <span className="underline ml-[3px]">Login</span>
            </button>
          </p>
          <div className="form w-full flex flex-col gap-[16px]">
            <FormItem label="Email" onChange={handleEmailChange} placeholder="mrjhon@gmail.com" />
            <FormItem label="Username" onChange={handleUsernameChange} placeholder="Jhon" />

            <PasswordForm label="Password" onChange={handlePasswordChange} placeholder="Enter your password" />
            <div className="flex flex-col gap-[8px] w-full">
              {error && <p className="mt-[3px]  pl-[14px] text-11-400 text-red">{error}</p>}
              <Button disabled={isButtonDisabled} className="mt-[16px]" onClick={handleSubmit}>
                Register
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
